import { useCsRoutes } from '@shared/api'

import { useSubscriptionStore } from '../model/subscription-store/store'

interface SubscriptionRetryApiOptions {
  onSuccess?: (data: any) => void
  onError?: (err: any) => void
}

export const useSubscriptionRetryApi = async (options?: SubscriptionRetryApiOptions): Promise<any> => {
  const { $axios } = useNuxtApp()

  const subscriptionStore = useSubscriptionStore()

  const subscriptionId = subscriptionStore.paymentRetryData!.subscription!.id

  const url = useCsRoutes('subscriptions.retry', {
    '[subscription_id]': subscriptionId,
  })

  subscriptionStore.setLoading(true)

  try {
    const { data } = await $axios.post(url!)
    options?.onSuccess?.(data)
    return data
  } catch (err) {
    options?.onError?.(err)
    return null
  } finally {
    subscriptionStore.setLoading(false)
  }
}
